import { FINISH_SWATCH } from "@/data/products";

const LIGHT = new Set(["#FFFFFF", "#F3F2EE", "#ECE8E0", "#E3DED2", "#DEE6EA", "#F5F4F0", "#F3F0EA", "#E8DDC6"]);

const FinishSwatch = ({ finish, size = "h-3.5 w-3.5" }) => {
  const color = FINISH_SWATCH[finish];
  if (!color) return null;
  return (
    <span
      aria-hidden="true"
      className={`inline-block shrink-0 rounded-full ${size} ${LIGHT.has(color) ? "border border-ink/20" : ""}`}
      style={{ background: color }}
    />
  );
};

export default FinishSwatch;
